import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Link, useParams} from 'react-router-dom';
import GoBackButton from "../layout/GoBackButton";
import {downloadSaleDocument, getSale} from "../../actions/sale";
import MoneyFormat from "../layout/MoneyFormat";
import Moment from "react-moment";
import {Download} from "react-feather";
import ButtonLoader from "../layout/ButtonLoader";
import ColorPicker from "../layout/ColorPicker";

const SalePage = () => {

    useEffect(() => {
        dispatch(getSale(id));
    }, [getSale]);

    const dispatch = useDispatch();

    const {id} = useParams();

    const {sale} = useSelector(state => state.sale);

    const [isLoading, setIsLoading] = useState(false);
    const [textColor, setTextColor] = useState('#000000');
    
    const onDownload = async (id) => {
        setIsLoading(true);
        const data = await dispatch(downloadSaleDocument(id, textColor));
        if (data.hasOwnProperty('url')){
            const {url} = data
            window.open(url, '_blank');
        }
        setIsLoading(false);
    };

    // Function to determine item label based on deletion status
    const getItemLabel = (sale, item) => {
        if (sale?.deleted_at) {
            return "O'chirilgan"; // Sale is deleted
        } else if (item?.deleted_at) {
            return "O'zgartirilgan"; // Sale is active but item is deleted
        }
        return null; // No label needed
    };

    // Function to get item styling based on deletion status
    const getItemStyle = (sale, item) => {
        if (sale?.deleted_at || item?.deleted_at) {
            return {
                backgroundColor: '#ffeeee',
                border: '1px solid #dc3545',
                borderRadius: '4px',
                padding: '8px',
                margin: '4px 0'
            };
        }
        return {
            padding: '4px 0'
        };
    };

    // Function to get text styling for item content
    const getItemTextStyle = (sale, item) => {
        // If sale is active but item is deleted, add strikethrough
        if (!sale?.deleted_at && item?.deleted_at) {
            return {
                textDecoration: 'line-through',
                opacity: 0.7
            };
        }
        return {};
    };

    return (
        <div>
            <main className="content mt-0 pt-0">
                <div className="container-fluid p-0">

                    <div className="row mb-2">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-3">
                                <strong>Sotuv</strong> ma'lumotlari 
                                {sale?.deleted_at && (
                                    <span className="badge bg-danger ms-2">O'chirilgan</span>
                                )}
                            </h1>
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <div className="d-flex align-items-center justify-content-end mb-2">
                                    <span className="me-2 small text-muted">Text Color:</span>
                                    <ColorPicker 
                                        selectedColor={textColor} 
                                        onColorChange={setTextColor}
                                        disabled={isLoading}
                                    />
                                </div>
                                <button onClick={() => onDownload(id)}
                                        className="btn text-center btn-primary -item-right me-2">
                                    {isLoading && (
                                        <ButtonLoader/>
                                    )}
                                    Накладной юклаш
                                    <Download className={'ms-2'}/>
                                </button>
                                <GoBackButton/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 col-lg-12">
                            <div className="card ">
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">Klient
                                            ma'lumotlari</h5>
                                    </div>
                                    <div className="card-body text-center">
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Nomi:</div>
                                            <div className="text-muted  m-0">
                                                <Link to={`/clients/${sale?.client?.id}`}>{sale?.client?.name}</Link>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Javobgar shaxs:</div>
                                            <div className="text-muted  m-0">
                                                {sale?.client?.contractor}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Telefon:</div>
                                            <div className="text-muted  m-0">
                                                {sale?.client?.phone}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Turi:</div>
                                            <div className="text-muted  m-0">
                                                {sale?.client?.type}
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Bank hisobi:</div>
                                            <div className="text-muted  m-0">
                                                {sale?.client?.bank_account}
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Bazaga qo'shilgan:</div>
                                            <div className="text-muted  m-0">
                                                <Moment date={sale?.client?.created_at} format={'YYYY-MM-DD'}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">Sotuvchi</h5>
                                    </div>
                                    <div className="card-body text-center">
                                    <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Ismi:</div>
                                            <div className="text-muted  m-0">
                                                <Link to={`/users/${sale?.seller?.id}`}>{sale?.seller?.name}</Link>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Email:</div>
                                            <div className="text-muted  m-0">
                                                {sale?.seller?.email}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h5 className="card-title text-dark text-decoration-underline mb-0">Mahsulotlar/Materiallar</h5>
                                    </div>
                                    <div className="card-body text-center">
                                        {sale?.items?.map((item, index) => {
                                            const itemLabel = getItemLabel(sale, item);
                                            const itemStyle = getItemStyle(sale, item);
                                            const itemTextStyle = getItemTextStyle(sale, item);
                                            
                                            return (
                                                <div key={index} className="d-flex align-items-center" style={itemStyle}>
                                                    <div className="card-title m-2">
                                                        <Link to={`/products/${item.sellable_id}`}>
                                                            {item.name}
                                                        </Link>:
                                                    </div>
                                                    <div className="text-muted m-0" style={itemTextStyle}>
                                                        {parseFloat(item.quantity).toFixed(2)} {item.unit?.symbol} x <MoneyFormat value={item.price}/> =
                                                        <MoneyFormat value={item.price * item.quantity}/> so'm
                                                        {itemLabel && (
                                                            <span className={`badge ms-2 ${sale?.deleted_at ? 'bg-danger' : 'bg-warning'}`}>
                                                                {itemLabel}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div className="d-flex align-items-center mt-3">
                                            <div className="card-title m-2">Jami summa:</div>
                                            <div className="text-muted m-0">
                                                <MoneyFormat value={sale?.sum}/> so'm
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-0 mb-3">
                                    <div className="card-header">
                                        <h4 className="card-title text-dark text-decoration-underline mb-0">Umumiy ma'lumotlar</h4>
                                    </div>
                                    <div className="card-body text-center">
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Sotuv sanasi:</div>
                                            <div className="text-muted m-0">
                                                {sale?.date}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Sotuv qo'shilgan:</div>
                                            <div className="text-muted m-0">
                                                {sale?.created_at}
                                            </div>
                                        </div>
                                        {sale?.deleted_at && (
                                            <div className="d-flex align-items-center">
                                                <div className="card-title m-2">O'chirilgan:</div>
                                                <div className="text-danger m-0">
                                                    <Moment date={sale.deleted_at} format={'DD.MM.YYYY HH:mm'}/>
                                                </div>
                                            </div>
                                        )}
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Transport raqami:</div>
                                            <div className="text-muted m-0">
                                                {sale?.transport_number || '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Haydovchi:</div>
                                            <div className="text-muted m-0">
                                                {sale?.driver_name || '-'}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="card-title m-2">Izoh:</div>
                                            <div className="text-muted m-0">
                                                {sale?.description || '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </main>
        </div>
    )
        ;
};

export default SalePage;